import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Button, Row, Col } from 'reactstrap';

const StepModal = ({ isOpen, toggle, editingStep, formData, setFormData, onSubmit }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        {editingStep ? 'Chỉnh sửa Step' : 'Tạo Step Mới'}
      </ModalHeader>
      <Form onSubmit={onSubmit}>
        <ModalBody>
          <Row>
            <Col md="8">
              <FormGroup>
                <Label>Tên Step *</Label>
                <Input
                  type="text"
                  value={formData.stepName}
                  onChange={(e) => setFormData({...formData, stepName: e.target.value})}
                  placeholder="Nhập tên step..."
                  required
                />
              </FormGroup>
            </Col>
            <Col md="4">
              <FormGroup>
                <Label>Thứ tự *</Label>
                <Input
                  type="number"
                  value={formData.stepOrder}
                  onChange={(e) => setFormData({...formData, stepOrder: parseInt(e.target.value)})}
                  min="1"
                  required
                />
              </FormGroup>
            </Col>
            <Col md="12">
              <FormGroup>
                <Label>Mô tả</Label>
                <Input
                  type="textarea"
                  rows="3"
                  value={formData.stepDescription}
                  onChange={(e) => setFormData({...formData, stepDescription: e.target.value})}
                  placeholder="Mô tả cho step..."
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>Loại Step *</Label>
                <Input
                  type="select"
                  value={formData.stepType}
                  onChange={(e) => setFormData({...formData, stepType: e.target.value})}
                  required
                >
                  <option value="quiz">Quiz</option>
                  <option value="information">Information</option>
                  <option value="verification">Verification</option>
                </Input>
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label className="d-block">Options</Label>
                <div className="d-flex gap-3 mt-2">
                  <div className="form-check">
                    <Input
                      type="checkbox"
                      className="form-check-input"
                      checked={formData.isRequired}
                      onChange={(e) => setFormData({...formData, isRequired: e.target.checked})}
                    />
                    <Label className="form-check-label">Required</Label>
                  </div>
                  <div className="form-check">
                    <Input
                      type="checkbox"
                      className="form-check-input"
                      checked={formData.isActive}
                      onChange={(e) => setFormData({...formData, isActive: e.target.checked})}
                    />
                    <Label className="form-check-label">Active</Label>
                  </div>
                </div>
              </FormGroup>
            </Col>
            <Col md="12">
              <FormGroup>
                <Label>Step Config (JSON)</Label>
                <Input
                  type="textarea"
                  rows="4"
                  value={JSON.stringify(formData.stepConfig, null, 2)}
                  onChange={(e) => {
                    try {
                      const config = JSON.parse(e.target.value);
                      setFormData({...formData, stepConfig: config});
                    } catch (err) {
                      // Invalid JSON, don't update
                    }
                  }}
                  placeholder='{"requiredQuizzes": 1, "minScore": 70}'
                />
                <small className="text-muted">Enter valid JSON format</small>
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Hủy
          </Button>
          <Button color="primary" type="submit">
            <i className="fa fa-save me-2"></i>
            {editingStep ? 'Cập nhật' : 'Tạo mới'}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default StepModal;

